import styled, { BorderRadius, Color, Spacing, Font, css } from '@nfinite/react-hubstairs/styled'

import TextInputComponent from 'components/Commons/Inputs/TextInput'
import IconComponent from 'components/Commons/Icon'
import TooltipComponent from 'components/Commons/Tooltip'
import ButtonComponent from 'components/Commons/Button'
import { transparentize } from 'polished'

const ICON_SIZE = 20

export const ErrorInfo = styled('div')`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

ErrorInfo.Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${Color.get('alert')};
  ${BorderRadius.generate({ all: 'xs' })}
  ${Spacing.generatePadding({ all: 'xxs' })}
  ${Spacing.generateMargin({ horizontal: 'xxs' })}
`

ErrorInfo.Icon = styled(IconComponent)`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
`

ErrorInfo.Text = styled('div')`
  color: ${Color.get('text', 'contrast')};
  ${Font.generate({ size: 's' })}
  ${Spacing.generateMargin({ left: 'xs' })}
`

export const LoadingDotsWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`
export const ImageDropZone = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${Spacing.get('m')}px;
`

export const InfoTitle = styled('div')`
  display: flex;
  justify-content: center;
  gap: ${Spacing.get('xs')}px;
`

InfoTitle.Icon = styled(IconComponent)`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
`

export const TextInput = styled(TextInputComponent)`
  width: auto;
  flex-grow: 1;
`

export const Clear = styled(IconComponent)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & > svg {
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
    fill: ${Color.get('text')};
  }
`

export const CloseTooltipIcon = styled(IconComponent)`
  position: absolute;
  right: 0;
  cursor: pointer;

  & > svg {
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
    fill: ${Color.get('text')};
  }
`

export const PictureIcon = styled(IconComponent)`
  height: 100%;
  & > svg {
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
  }
`
export const BrowseButton = styled(ButtonComponent)`
  min-width: fit-content;
  display: flex;
  ${Spacing.generateMargin({ left: 'xs' })}
`
BrowseButton.Icon = styled(IconComponent)`
  width: 12px;
  height: 12px;
`

BrowseButton.Label = styled('div')`
  ${Spacing.generatePadding({ right: 'xs' })};
`
BrowseButton.Content = styled('div')`
  display: flex;
  align-items: center;
`

export const UploadIcon = styled(IconComponent)`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}
  & svg {
    fill: ${Color.get('gray')};
    color: red;
  }
`

export const UploadTooltip = styled(TooltipComponent)`
  & > .react-tooltip-lite {
    background-color: ${Color.get('background')};
    color: ${Color.get('background', 'contrast')};
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.4);
    display: flex !important;
    position: absolute;
  }
  .react-tooltip-lite-arrow {
    border-color: ${Color.get('background')};
  }
  ${Spacing.generateMargin({ left: 'xxs' })}
`

export const TooltipContainer = styled('div')`
  height: 100%;
  min-width: 500px;
  min-height: 340px;
  display: flex;
  flex-direction: column;
  ${Spacing.generatePadding({ all: 'm' })}
`

export const UploadZone = styled('div')`
  height: 100%;
  border: 1px dashed
    ${({ isDragActive, errorBorder }) =>
      isDragActive ? Color.get('primary') : errorBorder ? Color.get('alert') : Color.get('gray')};
  ${BorderRadius.generate({ all: 'm' })}
  background-color:  ${({ isDragActive, theme }) =>
    isDragActive ? transparentize(0.8, theme.getColor('primary')) : Color.get('gray', 'lighter')};
  ${Spacing.generatePadding({ top: 'xxs', bottom: 's' })}
  display: flex;
  flex-direction: column;
`

export const UploadTitle = styled('div')`
  position: relative;
  display: flex;
  justify-content: center;
  ${Font.generate({ size: 's', weight: 'bold' })}
  ${Spacing.generateMargin({ bottom: 'm' })}
`

export const PictureWrapper = styled('div')`
  cursor: pointer;
`

export const LineWrapper = styled('div')`
  ${Spacing.generatePadding({ horizontal: 's' })}
`

export const Line = styled('div')`
  width: 100%;
  text-align: center;
  border-bottom: 1px solid ${Color.get('gray', 'second')};
  line-height: 0.1em;
  ${Spacing.generateMargin({ vertical: 's' })}
`

export const DropZoneContainer = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const InputContainer = styled('div')`
  ${Spacing.generatePadding({ horizontal: 's' })}
`

export const InputZoneContent = styled('div')`
  display: flex;
  gap: ${Spacing.get('xs')}px;
`

export const Button = styled(ButtonComponent)`
  ${Font.generate({ size: 's' })};
  min-width: unset;
  max-width: 80px;
`

export const MiddleText = styled('span')`
  background: ${Color.get('gray', 'lighter')};
  color: ${Color.get('gray', 'second')};
  ${Spacing.generatePadding({ horizontal: 'xs' })}
`
export const Container = styled('div')`
  height: 100%;
  position: relative;

  #image_search_input {
    display: none;
  }

  &:focus {
    outline: 0;
  }
`

export const DropZoneContent = styled('div')`
  display: flex;
  justify-content: center;
`

export const PictureSearchTooltip = styled(TooltipComponent)`
  & > .react-tooltip-lite {
    background-color: ${Color.get('background', 'contrast')};
    color: ${Color.get('background')};
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.4);
    display: flex !important;
    position: absolute;
    ${BorderRadius.generate({ all: 'm' })}
  }
`
PictureSearchTooltip.Content = styled('div')`
  ${Spacing.generateMargin({ all: 'xs' })}
`

export const DragActiveMessage = styled('div')`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  ${Font.generate({ size: 'default' })}
`
